export default __webpack_public_path__ + "static/media/gistswap-card01.8202703c.png";